var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fields mb-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',[_vm._v(_vm._s(_vm.$t('General')))]),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
            id: 'maps_general_debug',
            label: 'Debug information',
            disabled: false,
            description: 'Display some debug information about the map',
            values: _vm.fieldValues('on_off'),
            target: 'game'
          },false))],1),_c('div',{staticClass:"mb-4"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Elements')))]),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
            id: 'maps_elements_eta',
            label: 'ETA information',
            disabled: false,
            description:
              'Display the remaining or ETA time and the current remaining distance to the destination',
            values: _vm.fieldValues('on_off'),
            target: 'game'
          },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
            id: 'maps_elements_speedAndGear',
            label: 'Speed and gear',
            disabled: false,
            description: 'Display the current speed and gear',
            values: _vm.fieldValues('on_off'),
            target: 'game'
          },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
            id: 'maps_elements_mapControls',
            label: 'Map controls',
            disabled: false,
            description:
              'Display map controls (Recenter, focus on user, zoom in and zoom out)',
            values: _vm.fieldValues('on_off'),
            target: 'game'
          },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
            id: 'maps_elements_speedLimit',
            label: 'Speed limit',
            disabled: false,
            description: 'Display current speed limit',
            values: _vm.fieldValues('on_off'),
            target: 'game'
          },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
            id: 'maps_elements_rotateWithPlayer',
            label: 'Map rotation',
            disabled: !_vm.configEnabled('maps_elements_mapControls'),
            description: 'Enable or disable the map rotation on the first load',
            values: _vm.fieldValues('on_off'),
            target: 'game'
          },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
            id: 'maps_map_navigationRemaining',
            label: 'Navigation ETA',
            disabled: !_vm.configEnabled('maps_elements_eta'),
            description:
              'Display the due date or the remaining time for the current route',
            values: _vm.fieldValues('maps_map_navigationRemaining'),
            target: 'game'
          },false))],1)]),_c('div',{staticClass:"fields mb-4"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Tiles')))]),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'maps_map_activeMap',
          label: 'Active map',
          disabled: false,
          description: 'Change the active map',
          values: _vm.fieldValues('maps_map_activeMap'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'maps_map_type',
          label: 'Kind of map',
          disabled: false,
          description:
            'Use the ETS2 or ATS map automatically or use the modded map',
          values: _vm.fieldValues('maps_map_type'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'maps_map_tilesRemotePath',
          label: 'Remote tiles location',
          disabled: _vm.configEnabled('maps_map_tilesRemoteUseCustom'),
          description: 'Set a remote location for the map tiles.',
          values: _vm.fieldValues('maps_map_tilesRemotePath'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'maps_map_tilesRemoteUseCustom',
          label: 'Custom tiles',
          disabled: false,
          description: 'Set to ON if you wan to use a custom tiles location',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldInput',_vm._b({},'ConfigFieldInput',{
          id: 'maps_map_tilesRemoteCustomPath',
          label: 'Custom tiles location',
          disabled: !_vm.configEnabled('maps_map_tilesRemoteUseCustom'),
          description: 'The host of your tiles location',
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'maps_map_tilesVersion',
          label: 'Game version',
          disabled: _vm.configEnabled('maps_map_tilesRemoteUseCustom'),
          description:
            'Get tiles for the latest game version, or for the specified game version',
          values: _vm.fieldValues('maps_map_tilesVersion'),
          target: 'game'
        },false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }